let state = {}

const setState = () => {
	state.enableTransparentNav = true;
	state.mobileNavOpen = false;
	state.showNavChildren = false;
	state.isIE = document.documentElement.classList.contains('ie');
}

export { state, setState };
